import useSourceFlowCollection from "@/hooks/useSourceFlowCollection";
import data from "@/.sourceflow/jobs.json";

const SECTOR_CATEGORY_ID = "54182828-5365-45cf-ac98-4f86ec1177cd";
const LOCATION_CATEGORY_ID = "3259bf19-6cd5-41c8-81cc-5217e80df31c";
// Aerospace and Defence sector — used as the fallback when the featured selection is empty
const AEROSPACE_AND_DEFENCE_SECTOR_ID = "02cad2c0-448a-427d-a9d0-9953b609484c";

const filterBySector = (jobs, sectorIds) =>
  jobs.filter((job) => job?.categories.find((cat) => cat.id === SECTOR_CATEGORY_ID)?.values.some((filter) => sectorIds?.includes(filter.id)));

export const useJobs = ({ sectors = null, locations = null, featuredOnly = false, limit = 8 } = {}) => {
  let collection = useSourceFlowCollection(data.jobs);
  let sectorFilter = sectors;

  if (featuredOnly) {
    let featured = collection.filter((job) => job?.featured);

    // Narrow featured roles to the sector selected on the component (if any) before deciding on the fallback
    if (sectorFilter && sectorFilter.length > 0) {
      featured = filterBySector(featured, sectorFilter);
    }

    if (featured.length > 0) {
      collection = featured;
      sectorFilter = null; // sector already applied above
    } else {
      // Fallback: no featured roles in the selected sector — show Aerospace and Defence roles instead
      sectorFilter = [AEROSPACE_AND_DEFENCE_SECTOR_ID];
    }
  }

  if (sectorFilter && sectorFilter.length > 0) {
    collection = filterBySector(collection, sectorFilter);
  }

  if (locations && locations.length > 0) {
    collection = collection.filter((job) => job?.categories.find((cat) => cat.id === LOCATION_CATEGORY_ID)?.values.some((filter) => locations?.includes(filter.id)));
  }

  if (limit) {
    return collection.slice(0, limit);
  }

  return collection;
};

export default useJobs;
